export default store => {
	// The `storage` event only fires in OTHER tabs than the one that wrote the key - the tab
	// that itself performs (or waits for) a refresh already syncs store.state.auth.token via
	// its own dispatch in fetcher.js. A tab that is otherwise idle - no in-flight GraphQL
	// request to trigger that path - never runs any of those sync points, so file requests
	// reading store.state.auth.token (CFilesExplorer/FileListing.vue, CFilesUpload.vue,
	// PdfCanvas.vue, ViewTemplatesFunction.vue) would keep sending the pre-rotation access
	// token there until that tab happened to make a request of its own. This listener covers
	// every such tab unconditionally, for every writer of the key (refresh, login, logout).
	window.addEventListener("storage", event => {
		if (event.key !== process.env.VUE_APP_TOKEN_KEY) return
		// event.newValue is a snapshot of the write that queued this event, not necessarily the
		// CURRENT value - if a second write (a fast login-then-refresh) fires before this handler
		// runs, this event's value is already stale even though its own event still delivers.
		// Comparing against current storage discards it instead of regressing the Vuex mirror to
		// an older token; the newer write's own event (already queued right behind this one) will
		// apply the correct value a moment later.
		if (localStorage.getItem(event.key) !== event.newValue) return
		store.dispatch("auth/setAccessToken", event.newValue)
	})
}
